var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("NEXT")]),_vm._v(" "),_c('div',[(_vm.isNextGameALinkedGame)?_c('span',{staticClass:"fa fa-link"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.nextGameCountdownAsString))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4299989c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/_default/_components/next-game/next-game.html
// module id = null
// module chunks = 